(() => {
  if (window.NavelisProductResponses) return;
  const entries = new Map();
  const ttl = 20000, limit = 12, maxLength = 300000;
  let background = 0;
  const keyFor = value => { const url = new URL(value, window.location.origin); if (url.origin !== window.location.origin) throw new Error('Unexpected product origin'); url.hash = ''; url.searchParams.sort(); return url.href; };
  const allowed = () => !document.hidden && !window.Shopify?.designMode && !window.navigator?.connection?.saveData && !/^(slow-)?2g$/.test(window.navigator?.connection?.effectiveType || '');
  const remember = (key, html) => {
    if (typeof html !== 'string' || html.length > maxLength) { entries.delete(key); return; }
    entries.delete(key); entries.set(key, { html, expires: Date.now() + ttl });
    while (entries.size > limit) { const oldest = entries.keys().next().value; entries.get(oldest).controller?.abort(); entries.delete(oldest); }
  };
  const clear = () => { for (const entry of entries.values()) entry.controller?.abort(); entries.clear(); };
  const read = (url, { signal, errorMessage = 'Product unavailable' } = {}) => {
    const key = keyFor(url);
    if (signal?.aborted) return Promise.reject(new DOMException('Aborted', 'AbortError'));
    let entry = entries.get(key);
    if (entry?.html && entry.expires <= Date.now()) { entries.delete(key); entry = null; }
    let pending;
    if (entry?.html) pending = Promise.resolve(entry.html);
    else if (entry?.promise) pending = entry.promise;
    else {
      const controller = new AbortController();
      entry = { controller };
      pending = fetch(key, { headers: { Accept: 'text/html' }, signal: controller.signal }).then(response => {
        if (!response.ok) throw new Error(errorMessage);
        return response.text();
      }).then(html => {
        if (entries.get(key) === entry && !controller.signal.aborted) remember(key, html);
        return html;
      }).catch(error => { if (entries.get(key) === entry) entries.delete(key); throw error; });
      entry.promise = pending;
      entries.set(key, entry);
      while (entries.size > limit) { const oldest = entries.keys().next().value; entries.get(oldest).controller?.abort(); entries.delete(oldest); }
    }
    if (!signal) return pending;
    return new Promise((resolve, reject) => {
      const abort = () => reject(new DOMException('Aborted', 'AbortError'));
      signal.addEventListener('abort', abort, { once: true });
      pending.then(resolve, reject).finally(() => signal.removeEventListener('abort', abort));
    });
  };
  const prefetch = async url => {
    if (!allowed() || background >= 2) return;
    background++;
    try { await read(url); } catch {} finally { background--; }
  };
  window.NavelisProductResponses = { status: url => { const e = entries.get(keyFor(url)); return e?.html && e.expires > Date.now() ? 'memory' : e?.promise ? 'pending' : 'network'; }, read, prefetch, allowed, prime: (url, html) => { const key = keyFor(url); if (!entries.has(key)) remember(key, html); }, clear };
  ['cart:updated', 'product:purchase-option-change', 'shopify:section:load'].forEach(name => document.addEventListener(name, clear));
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); });

  // Warm only the colour the shopper points to. Native navigation retains each
  // colour product's own template, app blocks, metadata and browser history.
  const documents = new Map();
  const anticipate = event => {
    const link = event.target.closest('[data-colour-product], [data-quick-view-trigger]');
    if (!link || !allowed()) return;
    if (link.hasAttribute('data-quick-view-trigger')) {
      const url = new URL(link.dataset.productUrl, window.location.origin);
      url.searchParams.set('section_id', 'quick-view');
      prefetch(url.href);
    } else if (!window.NavelisColours && !link.hasAttribute('aria-current')) {
      const url = keyFor(link.href);
      if (documents.has(url)) return;
      const hint = document.createElement('link'); hint.rel = 'prefetch'; hint.href = url;
      document.head.append(hint); documents.set(url, hint);
      while (documents.size > 3) { const [key, old] = documents.entries().next().value; old.remove(); documents.delete(key); }
    }
  };
  document.addEventListener('pointerover', anticipate);
  document.addEventListener('focusin', anticipate);
})();
